import React from 'react';

import {Field} from 'redux-form';

import {required, validDate} from 'utils/validators';

import {DateField, MoneyField} from 'components/Fields';
import FormField from 'components/FormField';
import Label from 'components/Label';

import './styles.css';

const OfferSection = () => (
  <div className="offerSection">
    <div className="dateInputsRow">
      <FormField className="startDate">
        <Label>Start</Label>
        <Field
          name="startDate"
          className="date"
          validate={[validDate]}
          component={DateField}
        />
      </FormField>
      <FormField className="endDate">
        <Label>End</Label>
        <Field name="endDate" validate={[validDate]} component={DateField} />
      </FormField>
    </div>
    <FormField>
      <Label>Deposit</Label>
      <Field name="roomDeposit" validate={[required]} component={MoneyField} />
    </FormField>
    <FormField>
      <Label>Rent</Label>
      <Field name="pwRent" validate={[required]} component={MoneyField} />
    </FormField>
  </div>
);

export default OfferSection;
